import * as React from 'react';
import { observer } from 'mobx-react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface ClientItemEditorViewProps  {
	clientRequest: DropdownRequest<ClientItem>;
	value: number | null;
	mode: ControlMode;
	onChanged: (number: ClientItem | null) => void;
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}
interface State {
	required?: boolean;
}
@observer
export class ClientItemEditorView extends React.Component<ClientItemEditorViewProps, State> {
	constructor(props) {
		super(props);
		this.state = { required:this.props.required}
	}
	componentWillReceiveProps(nextProps: Readonly<ClientItemEditorViewProps>, nextContext: any) {
		
		if (nextProps.required !=this.state.required) {
			this.setState({
				required: nextProps.required
			});
		}

	}
	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Customer';
		}

		return <div className='filter-panel'>
			<DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				model={this.props.value}
				required={this.state.required}
				disabled={this.props.mode == 'display'}
				onChanged={(item) => {
					this.props.onChanged(item != null ? item : null)
					this.setState({
						required: this.state.required && item == null
					});
				}}
				request={this.props.clientRequest}
				keyField="id"
				textField="displayName"
				placeholder="Select a Client..."
			/>
			<div style={{ display: 'inline-flex', alignItems: 'flex-end', marginBottom: this.state.required?'22px':'6px' }}>
				{this.props.children}
			</div>
		</div>;
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/client-item-editor.view.tsx